// extracted by mini-css-extract-plugin
export default {"amp_icon_card":"iconcard_amp_icon_card__CBIch","amp_card_logo_wrap":"iconcard_amp_card_logo_wrap__HJ4oD","disabled":"iconcard_disabled__0X04a"};